import { FilterFormComponentName } from '@/components/filter-form/components';
import { FieldName } from '@/store/events/filters/fields';

export const schema = {
  module: 'area_records',
  action: 'area_records/get',
  fields: [
    {
      name: FieldName.CreatedDateGte,
      control: {
        i18nLabel: ['area_records_created_date', 'from'],
        component: [
          FilterFormComponentName.Datetime,
          {
            type: 'datetime',
            clearFieldsOnChange: [FieldName.Page, FieldName.Id]
          }
        ]
      }
    },
    {
      name: FieldName.CreatedDateLte,
      control: {
        i18nLabel: 'till',
        component: [
          FilterFormComponentName.Datetime,
          {
            type: 'datetime',
            clearFieldsOnChange: [FieldName.Page, FieldName.Id]
          }
        ]
      }
    },
    {
      name: FieldName.BodyCountGte,
      control: {
        i18nLabel: ['area_records_body_count', 'from'],
        component: [
          FilterFormComponentName.Input,
          {
            number: true,
            clearFieldsOnChange: [FieldName.Page, FieldName.Id]
          }
        ]
      }
    },
    {
      name: FieldName.BodyCountLte,
      control: {
        i18nLabel: 'till',
        component: [
          FilterFormComponentName.Input,
          {
            number: true,
            clearFieldsOnChange: [FieldName.Page, FieldName.Id]
          }
        ]
      }
    }
  ]
};
